import React, { Fragment } from "react";
import AppButton from "@vcomponents/AppButton";
import { arrowSingleIcon, arrowUpDoubleIcon } from "@src/assets/images/svgs";

import { generatePagination, pagination } from "./data";

import { observer } from "mobx-react-lite";
import { Input } from "reactstrap";
import { debounce } from "lodash";
import "./style.scss";

import { CustomFormattedMessage } from "@src/utility/context/CustomFormattedMessage";

/**
 * TICKETS TABLE PAGINATION
 * @param {Object} props
 * @param {Object} props.table
 * @returns
 */
const Pagination = observer((props) => {
  const { table } = props;
  const [pageIndex, setPageIndex] = React.useState(
    table.getState()?.pagination?.pageIndex + 1
  );
  const [pageIndexTextField, setPageIndexTextField] = React.useState(
    table.getState()?.pagination?.pageIndex + 1
  );

  const setPageIndexOnPageChange = React.useCallback(
    (payload) => {
      const value = payload;
      if (value <= table.pageCount && value >= 0) {
        setPageIndex(value);
        table.setPageIndex(value - 1);
      }
    },
    [table.pageCount]
  );

  const setPageIndexOnInputChange = React.useCallback(
    (payload) => {
      let value = payload?.target?.value;
      console.log(value);
      if (value <= table.pageCount && value >= 0) {
        if (value == 0) {
          value = 1;
        }
        setPageIndexTextField(value);
        tablePageIndexUpdataCall(value);
      }
    },
    [table.pageCount]
  );

  const tablePageIndexUpdataCall = debounce((e) => {
    setPageIndex(e - 1);
    table.setPageIndex(e - 1);
  }, 2000);

  const gotoFirstPage = React.useCallback(
    () => table.setPageIndex(0),
    [table.pageCount]
  );

  const gotoLastPage = React.useCallback(
    () => table.setPageIndex(table.getPageCount() - 1),
    [table.pageCount]
  );

  React.useEffect(() => {
    setPageIndex(table.getState()?.pagination?.pageIndex + 1);
    setPageIndexTextField(table.getState()?.pagination?.pageIndex + 1);
  }, [table?.getState()?.pagination?.pageIndex]);

  const pages = generatePagination(pageIndex, table.pageCount);
  const isLoading = pages?.length === 0;
  return (
    <div className="tickets-pagination">
      <div className="pagination-actions">
        <div className="pagination-actions__pageInfo d-none d-lg-flex">
          <p>
            <CustomFormattedMessage id="page" defaultMessage={"page"} />
          </p>
          <Input
            className="pagination-actions__pageInfo--input"
            min={1}
            disabled={isLoading}
            type="number"
            value={pageIndexTextField}
            onChange={setPageIndexOnInputChange}
          />
          <p>
            <CustomFormattedMessage id="of" defaultMessage={"of"} />
          </p>
          <p>{table.pageCount}</p>
        </div>
        <div className="pagination-actions__navigation">
          {isLoading ? (
            <p>
              <CustomFormattedMessage
                id="Loading pages..."
                defaultMessage={"Loading pages..."}
              />
            </p>
          ) : (
            <Fragment>
              <AppButton
                icon={arrowUpDoubleIcon}
                className="secondary-btn pagination-trigger-icon"
                onClick={gotoFirstPage} // Jumps to the first page
                disabled={!table.getCanPreviousPage() || !table.pageCount}
              />
              <AppButton
                icon={arrowSingleIcon}
                className="secondary-btn pagination-trigger-icon left-nav"
                onClick={table.previousPage}
                disabled={!table.getCanPreviousPage() || !table.pageCount}
              />
              {pages.map((item, index) => {
                const pageText =
                  typeof item === "object" && item.type === "ellipsis"
                    ? "..."
                    : item;
                const pageNumber =
                  typeof item === "object" && item.type === "ellipsis"
                    ? item.value
                    : item;
                const isActive = pageIndex === parseInt(pageNumber);
                return (
                  <AppButton
                    key={index}
                    text={pageText.toString()}
                    className={`${isActive ? "active" : ""} ${
                      window.innerWidth < 991 && !isActive
                        ? "d-none"
                        : "d-lg-flex"
                    } secondary-btn`}
                    onClick={() => setPageIndexOnPageChange(pageNumber)}
                  />
                );
              })}
              <AppButton
                icon={arrowSingleIcon}
                onClick={table.nextPage}
                className="secondary-btn pagination-trigger-icon right-nav"
                disabled={
                  table.getState().pagination.pageIndex + 1 ===
                    table.pageCount || !table.pageCount
                }
              />
              <AppButton
                icon={arrowUpDoubleIcon}
                className="secondary-btn pagination-trigger-icon"
                onClick={gotoLastPage}
                disabled={
                  table.getState().pagination.pageIndex + 1 ===
                    table.pageCount || !table.pageCount
                }
              />
            </Fragment>
          )}
        </div>

        <div className="pagination-actions__perPageToggle d-none d-lg-block">
          <Input
            disabled={isLoading}
            id="perPageToggler"
            value={table.getState().pagination.pageSize}
            onChange={(e) => {
              table.setPageSize(Number(e.target.value));
            }}
            name="select"
            type="select"
          >
            {pagination.rowsPerPage.map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                <span>
                  {pageSize} /&nbsp;
                  <CustomFormattedMessage id="page" defaultMessage={"page"} />
                </span>
              </option>
            ))}
          </Input>
        </div>
      </div>
    </div>
  );
});

export default Pagination;
